var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 10 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.448909 0.5C0.00824915 0.5 -0.14886 0.889018 0.163493 1.20909L3.76449 4.89701C3.76774 4.9005 3.7792 4.92872 3.7792 4.93141V8.11347C3.7792 8.23632 3.8377 8.3809 3.92252 8.46777L5.84136 10.433C5.98113 10.5762 6.22011 10.4747 6.22011 10.2723V4.93204C6.22011 4.92951 6.23218 4.90002 6.23482 4.89717L9.83581 1.20925C10.1488 0.888558 9.99276 0.500158 9.5504 0.500158L0.448909 0.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.aa844c01.svg";
export { ForwardRef as ReactComponent };